var checkUserInfo = function checkUserInfo() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'userInfo';

  // Return if called on server
  if (typeof document === 'undefined') {
    return;
  }

  try {
    var userInfoCookie = document.cookie.split('; ').find(function (row) {
      return row.startsWith(cookieName);
    });

    if (userInfoCookie) {
      return JSON.parse(decodeURIComponent(userInfoCookie.split('=')[1]));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Error while accessing userInfo cookie', error);
  }

  return;
};

export default checkUserInfo;